/**
 * @deprecated
 * This field doesn't use form-field component
 */
import { refCount, publishReplay, debounceTime} from 'rxjs/operators';
import {
    Component,
    ElementRef,
    AfterViewInit,
    OnDestroy,
    OnInit,
    Input,
    SimpleChanges,
    forwardRef,
    ChangeDetectorRef,
    Renderer2,
    OnChanges, NgZone
} from '@angular/core';

import _get from 'lodash-es/get';

// FIXME;  correctly defines the primeNg call
import { Calendar } from 'primeng/calendar';


import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { DateParserService } from 'libraries/service/date/dateParser.service';
import { IDateParserOptions } from "libraries/service/date/IDateParserOptions";
import { Subject, Observable } from 'rxjs';
import { DomHandler } from "primeng/dom";
import { EDateInputAdditionalClass } from "libraries/module/formbuilder/fields/date/date-additional-class.enum";

export const CALENDAR_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Calendar2months),
    multi: true
};

export interface ICalendarAdditionnalStyle {
    datePickerLeft?: string;
    datePickerRight?: string;
}


/**
 * Date-field
 * Generate date field with calendar
 * @deprecated
 * @extends GenericField
 * @implements IGenericField
 */
@Component({
    selector: 'p-calendar2months',
    templateUrl: './calendar2months.component.html',
    host: {
        '[class.ui-inputwrapper-filled]': 'filled',
        '[class.ui-inputwrapper-focus]': 'focus'
    },
    providers: [DomHandler, CALENDAR_VALUE_ACCESSOR],
    styleUrls: ["./calendar2months.component.scss"]
})
export class Calendar2months extends Calendar implements AfterViewInit, OnInit, OnChanges, OnDestroy, ControlValueAccessor {

    @Input()
    public onlyOneMonth: boolean = false;
    @Input()
    public past: boolean = false;
    @Input()
    public disabled: boolean = false;
    @Input()
    public isFull: boolean;
    @Input()
    public alignRightDatePicker: boolean;
    @Input()
    public alignTopDatePicker: boolean;
    @Input()
    public isPositionFixed: boolean = false;
    @Input()
    public additionnalClass: EDateInputAdditionalClass;

    public secondMonthDates: any[];

    public currentSecondMonthText: string;

    public currentSecondMonth: number;

    public currentSecondYear: number;

    public calendars: Array<{ month: number, year: number, dates: any[][] }> = [];

    private readonly userInputs: Subject<Event> = new Subject();
    private debouncedUserInputs: Observable<Event>;

    constructor(
        public readonly el: ElementRef,
        public readonly renderer: Renderer2,
        public readonly cd: ChangeDetectorRef,
        zone: NgZone,
        private readonly dateParser: DateParserService) {
        super(el, renderer, cd, zone);
    }

    /**
     * changes tracked:
     * yearRange
     */
    public ngOnChanges(changes: SimpleChanges): void {
        if (_get(changes, ['yearRange', 'currentValue'])) {
            this.setYearRange();
        }
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.setYearRange();

        this.debouncedUserInputs = this.userInputs.pipe(
            debounceTime(50),
            publishReplay(1),
            refCount(),);

        // Because on platforms with both angular and angularJS
        // it is very costly to run a $digest on every key stroke
        this.debouncedUserInputs
            .subscribe((event: Event) => {
                super.onUserInput(event);

                if (event.type === "blur"){
                    super.onInputBlur(event);
                }
            });
        }

    public ngAfterViewInit(): void {
        // TODO NG UPGRADE
    }

    public ngOnDestroy(): void {
        this.userInputs.complete();

        super.ngOnDestroy();
    }

    //Change createMonth
    public createMonth(month: number, year: number): { month: number; year: number; dates: any[]; weekNumbers: any[]; } {
        //Months : 0(janvier) to 11(december)
        //year : the good number
        this.dates = [];

        let month2: number;
        let year2: number;

        if (month < 11) {
            month2 = month + 1;
            year2 = year;
        } else if (month === 11) {
            month2 = 0;
            year2 = year + 1;
        }


        super.createMonth(month2, year2);
        this.secondMonthDates = this.dates;
        this.currentSecondMonth = this.currentMonth;
        this.currentSecondYear = this.currentYear;
        this.currentSecondMonthText = this.currentSecondMonthText;

        super.createMonth(month, year);


        //Display only One Calendar if inout 'onlyOneMonth' is true
        // §TODO: don't generate currentSecondMonth, currentSecondYear, and secondMonthDates if not needed
        if (this.onlyOneMonth) {
            this.calendars = [
                { month: this.currentMonth, year: this.currentYear, dates: this.dates}
            ];
        } else {
            this.calendars = [
                {month: this.currentMonth, year: this.currentYear, dates: this.dates},
                {month: this.currentSecondMonth, year: this.currentSecondYear, dates: this.secondMonthDates},
            ];
        }
        return { month: this.currentMonth, year: this.currentYear, dates: this.dates, weekNumbers: [] };
    }

    public onUserInput(event: Event): void {
        this.userInputs.next(event);
    }

    public onInputBlur(event: Event): void {
        // As we're not calling onUserInput on each input
        // we need to be sure to call this function on blur
        // If we do it directly, it causes issues when selecting the date
        // from the calendar (without entering it)
        // using the observable allows to first take the date from the calendar
        // and then call onUserInput
        this.userInputs.next(event);
    }

    public parseDate(value: string, format: string): Date {
        let parsed: Date;

        try {
            parsed = super.parseDate(value, format);
        } catch (error) {
            // invalid format
        }

        if (!parsed) {

            // §TODO+EJ+18-05-18: may be improved, to not be launched at every keypress
            const options: IDateParserOptions = {
                min: this.minDate,
                max: this.maxDate,
            };

            if (this.past){
                options.max = options.max || new Date();
                options.yearsIncrement = 100;
            }

            return this.dateParser.parse(value, options);
        }

        return parsed;
    }

    public openAndFocus(): void {
        setTimeout(() => {
                this.inputfieldViewChild.nativeElement.focus();
            }, 1
        );
    }

    public onInputFocus($event: Event): void {
        super.onInputFocus($event);
        this.inputfieldViewChild.nativeElement.select();
    }

    /**
     * copy of code contained in the original noOnInit
     */
    public setYearRange(): void {
        if (this.yearNavigator && this.yearRange) {
            this.yearOptions = [];
            const years: string[] = this.yearRange.split(':');
            const yearStart: number = +years[0];
            const yearEnd: number = +years[1];

            for (let i: number = yearStart; i <= yearEnd; i++) {
                this.yearOptions.push(i);
            }
        } else {
            // Default range 105 years
            const currentDate: number = (new Date()).getFullYear();
            this.yearOptions = this.range(currentDate, 1915, -1);
        }
    }

    /**
     * TODO ANGULAR UPGRADE
     * juste pour garder la compatibilité
     */
    public prevMonth($event: MouseEvent): void {
        console.warn("TODO ANGULAR UPGRADE prevMonth");
    }

    /**
     * TODO ANGULAR UPGRADE
     * juste pour garder la compatibilité
     */
    public nextMonth($event: MouseEvent): void {
        console.warn("TODO ANGULAR UPGRADE prevMonth");
    }

    /**
     * TODO ANGULAR UPGRADE
     * juste pour garder la compatibilité
     */
    public onDatePickerClick($event: MouseEvent): void {
        console.warn("TODO ANGULAR UPGRADE prevMonth");
    }

    private range(start: number, stop: number, step: number): number[] {
        return Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    }
}
